import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import './ReviewCard.css'

export default function ReviewCard({ review, currentUserId, onDelete }) {
  const navigate = useNavigate()

  const renderStars = (count) => {
    return '⭐'.repeat(count) + '☆'.repeat(5 - count)
  }

  const handleDelete = (e) => {
    e.stopPropagation() // Prevent navigation when clicking delete
    if (window.confirm(`Delete your review for ${review.game_name}? This will also remove the XP you earned!`)) {
      onDelete(review.review_id)
    }
  }

  const handleCardClick = () => {
    navigate(`/game/${review.game_id}`)
  }

  const isOwner = currentUserId && review.user_id === currentUserId

  return (
    <motion.div
      className="review-card"
      onClick={handleCardClick}
      whileHover={{ y: -4, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2 }}
    >
      {review.game_cover_url && (
        <div className="review-card-image">
          <img src={review.game_cover_url} alt={review.game_name} />
        </div>
      )}
      <div className="review-card-content">
        <h3 className="review-game-name">{review.game_name}</h3>

        <div className="review-ratings">
          <div className="rating-item">
            <span className="rating-label">Score:</span>
            <span className="rating-value score">{review.score_out_of_10}/10</span>
          </div>
          <div className="rating-item">
            <span className="rating-label">Stars:</span>
            <span className="rating-value stars">{renderStars(review.stars_out_of_5)}</span>
          </div>
          <div className="rating-item">
            <span className="rating-label">Recommend:</span>
            <span className={`rating-value thumbs ${review.thumbs_up ? 'thumbs-up' : 'thumbs-down'}`}>
              {review.thumbs_up ? '👍 YES' : '👎 NO'}
            </span>
          </div>
        </div>

        {review.xp_awarded && (
          <div className="quest-evaluation">
            <div className="xp-badge">
              <span className="xp-amount">+{review.xp_awarded} XP</span>
            </div>
            {review.quest_feedback && (
              <div className="quest-feedback">
                <span className="quest-icon">🎮</span>
                <span className="feedback-text">{review.quest_feedback}</span>
              </div>
            )}
          </div>
        )}

        {review.review_text && (
          <div className="review-text">
            <p>{review.review_text}</p>
          </div>
        )}

        {review.published_at && (
          <div className="review-meta">
            <span className="review-date">
              {new Date(review.published_at).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
              })}
            </span>
          </div>
        )}
      </div>

      {isOwner && onDelete && (
        <motion.button
          className="delete-review-btn"
          onClick={handleDelete}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          title="Delete review"
        >
          🗑️
        </motion.button>
      )}
    </motion.div>
  )
}
